module.exports = __webpack_public_path__ + "img/followup_timeline.7b98e15b.svg";